import MasterManagement from "../../components/MasterManagement";

const MasterManagementPage = () => {
  return <MasterManagement />;
};

export default MasterManagementPage;
